export default `float de( vec3 p){
    float ra = 0.5;  
    float rb = 0.1;  
    float h  = 0.4;  

    vec2 d = vec2( length(p.xz)-2.0*ra+rb, abs(p.y) - h );
    return min(max(d.x,d.y),0.0) + length(max(d,0.0)) - rb;
  }`